var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M8.7 12c2.43 0 4.4-2.015 4.4-4.5 0-2.486-1.97-4.5-4.4-4.5-2.43 0-4.4 2.014-4.4 4.5 0 2.485 1.97 4.5 4.4 4.5zm3.08 1.125h-.574a5.886 5.886 0 01-2.506.562 5.9 5.9 0 01-2.506-.562H5.62C3.07 13.125 1 15.24 1 17.85v1.462C1 20.244 1.74 21 2.65 21h9.45a1.746 1.746 0 01-.09-.75l.235-2.14.04-.39.272-.278 2.658-2.718c-.843-.973-2.063-1.6-3.435-1.6zm1.558 5.108l-.234 2.144a.555.555 0 00.605.62l2.093-.24 4.741-4.848-2.465-2.52-4.74 4.844zm9.422-5.78l-1.303-1.332a.81.81 0 00-1.162 0l-1.299 1.329-.14.144 2.467 2.52 1.437-1.469a.86.86 0 000-1.192z"
  }))));
}

export default SvgUserEdit;